export default __webpack_public_path__ + "static/Eclipse-1016372d48c9947ae0ccbb264fb5f942.gif";